import { render, staticRenderFns } from "./KiraKontratiAlacakFormWizard.vue?vue&type=template&id=8d63e1c6"
import script from "./KiraKontratiAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./KiraKontratiAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports